<div class="grid-container">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <legend class="usa-legend usa-legend--medium">HHG Scopes</legend>
    </div>
  </div>
  @if (vm$ | async; as vm) {
    <ng-container class="">
      <tabset class="maxw-full" #staticTabs>
        @if (hasDomesticApproval) {
          <tab heading="Intrastate" id="intrastate">
            @if (intraStateVM$ | async; as intraStates) {
              <form [formGroup]="intraStateFromGroup">
                <div class="grid-row grid-gap padding-top-4">
                  @for (scope of intraStateFromGroup.controls.scopes.controls; track scope; let i = $index) {
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
                      >
                      <label  class="define-label-checkbox"> <input type="checkbox"  id="{{ i }}" class="define-input-checkbox" [formControl]="scope" /> &ensp; {{intraStates[i]?.stateCountryName}}</label>
                    </div>
                  }
                </div>
                <div class="grid-row padding-y-4">
                  <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                      <button type="button" class="usa-button" (click)="viewAuditTrial('Intrastate')">View Audit Trail</button>
                    </li>
                    <li class="usa-button-group__item">
                      <button type="button" class="usa-button usa-button--outline" (click)="goBack()">
                        Back to TSP Approval
                      </button>
                    </li>
                    <li class="usa-button-group__item">
                      <button type="button" class="usa-button" (click)="saveIntraStateScopes(intraStates)"
                        [disabled]="!intraStateFromGroup.controls.scopes.touched">
                        Save
                      </button>
                    </li>
                  </ul>
                </div>
              </form>
            }
          </tab>
        }
        @if (hasDomesticApproval) {
          <tab heading="Interstate" id="interstate">
            @if (vm[1]; as serviceAreas) {
              <form [formGroup]="interStateFromGroup" style="width: 100%;">
                <div class="grid-row">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-4 padding-bottom-4">
                    <label class="usa-label" for="serviceArea">Origin Service Area</label>
                    <select id="serviceArea" name="serviceArea" class="usa-select maxw-full" formControlName="originServiceArea">
                      <option [ngValue]="null">..Select an Origin Service Area..</option>
                      @for (serviceArea of serviceAreas; track serviceArea) {
                        <option [ngValue]="serviceArea.stateCountryId">{{
                          serviceArea.stateCountryCode }} -
                          {{ serviceArea.stateCountryName }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
                <div class="grid-row">
                  @for (scope of interStateFromGroup.controls.scopes.controls; track scope; let i = $index) {
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                      <label  class="define-label-checkbox"
                          [ngStyle]="{'display': ((previousSelectedInterStateOriginServiceId | async) === 324 && serviceAreas[i].stateCountryId === 324) ||
                                ((previousSelectedInterStateOriginServiceId | async) === 329 && serviceAreas[i].stateCountryId === 329) ||
                                ((previousSelectedInterStateOriginServiceId | async) === 336 && serviceAreas[i].stateCountryId === 336) ||
                                (isSelectedServiceAreaCanadian && serviceAreas[i].parentCountryId === 365) ||
                                serviceAreas[i].stateCountryId === 374 || serviceAreas[i].stateCountryId === 352 || serviceAreas[i].stateCountryId === 355
                                ? 'none' : '' }">
                        <input type="checkbox"
                        id="{{ i }}" class="define-input-checkbox" [formControl]="scope" /> &ensp; {{ serviceAreas[i]?.stateCountryCode }} - {{ serviceAreas[i]?.stateCountryName }}</label>
                      </div>
                    }
                  </div>
                  <div class="grid-row padding-y-4">
                    <ul class="usa-button-group">
                      <li class="usa-button-group__item">
                        <button type="button" class="usa-button" (click)="viewAuditTrial('Interstate')">View Audit Trail</button>
                      </li>
                      <li class="usa-button-group__item">
                        <button type="button" class="usa-button usa-button--outline" (click)="goBack()">
                          Back to TSP Approval
                        </button>
                      </li>
                      @if (interStateFromGroup.controls.scopes.controls.length > 0) {
                        <li class="usa-button-group__item">
                          <button type="button" class="usa-button" (click)="saveInterstateScopes(serviceAreas, vm[0], vm[4])"
                            [disabled]="!interStateFromGroup.controls.scopes.touched">
                          Save
                        </button>
                      </li>
                    }
                    @if (true) {
                      <li class="usa-button-group__item">
                        <button type="button" class="usa-button" (click)="viewAllInterstateScope()">
                          View TSP’s Entire Interstate Scope
                        </button>
                      </li>
                    }
                  </ul>
                </div>
              </form>
            }
          </tab>
        }
        @if (hasInternationalApproval) {
          <tab heading="International" id="international">
            @if (vm[0]; as states) {
              <form [formGroup]="internationalFromGroup">
                @if (countries$ | async; as countries) {
                  <div class="grid-row grid-gap ">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-3">
                      <label class="usa-label" for="originInternationalCountry">Origin Country</label>
                      <select id="originInternationalCountry" name="originInternationalCountry" class="usa-select maxw-full"
                        formControlName="originInternationalCountry">
                        <option [ngValue]="null">..Select a Origin Country..</option>
                        @for (country of countries; track country) {
                          <option [ngValue]="country.stateCountryId">{{
                            country.stateCountryName }}
                          </option>
                        }
                      </select>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-3 define-switch-padding">
                      <label class="usa-label switch">
                        <input type="checkbox" formControlName="isAllStates" />
                        <span class="slider round"></span>
                      </label>
                      <label class="padding-left-2">Select all States</label>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-3 define-switch-padding">
                      <label class="usa-label switch">
                        <input type="checkbox" formControlName="isAllAlaskaCities" />
                        <span class="slider round"></span>
                      </label>
                      <label class="padding-left-2">Select all Alaska Cities</label>
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-3 define-switch-padding">
                      <label class="usa-label switch">
                        <input type="checkbox" formControlName="isAllCanadianProvinces" />
                        <span class="slider round"></span>
                      </label>
                      <label class="padding-left-2">Select all Canadian Provinces.</label>
                    </div>
                  </div>
                }
                <div class="grid-row padding-top-4">
                  @for (scope of internationalFromGroup.controls.scopes.controls; track scope; let i = $index) {
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                      <label  class="define-label-checkbox"> <input type="checkbox" [ngStyle]="{'visibility': states[i].stateCountryName !== 'ALASKA' && states[i].stateCountryCode2Digit !== 'HI' && states[i].stateCountryCode2Digit !== 'GU' && states[i].stateCountryCode2Digit !== 'FM' && states[i].stateCountryCode2Digit !== 'PR' ? 'visible' : 'hidden' }"  id="{{ i }}" class="define-input-checkbox" [formControl]="scope" /> &ensp; {{states[i]?.stateCountryName}}</label>
                    </div>
                  }
                </div>
                <!-- enum('Interstate','Intrastate','International') -->
                <div class="grid-row padding-y-2">
                  <ul class="usa-button-group">
                    <li class="usa-button-group__item">
                      <button type="button" class="usa-button" (click)="viewAuditTrial('International')">View Audit Trail</button>
                    </li>
                    <li class="usa-button-group__item">
                      <button type="button" class="usa-button usa-button--outline" (click)="goBack()"> Back to TSP Approval</button>
                    </li>
                    @if (internationalFromGroup.controls.scopes.controls.length > 0) {
                      <li class="usa-button-group__item">
                        <button type="button" class="usa-button" (click)="saveInternationalScopes(vm[0], vm[3])"
                            [disabled]="!internationalFromGroup.controls.scopes.touched && !internationalFromGroup.controls.isAllStates.touched
                                        && !internationalFromGroup.controls.isAllAlaskaCities.touched && !internationalFromGroup.controls.isAllCanadianProvinces.touched"> Save </button>
                      </li>
                    }
                  </ul>
                </div>
              </form>
            }
          </tab>
        }
      </tabset>
    </ng-container>
  }
</div>
